module.exports = __webpack_public_path__ + "img/x1024.26246608.png";